//--------------- IMPORTAÇÕES ---------------//
import { createContext, useState } from "react";



//--------------- CRIAÇÃO DO CONTEXTO DE TAGS ---------------//
export const TagsContext = createContext();



//--------------- EXPORTAÇÃO DO PROVIDER DO CONTEXTO DE TAGS ---------------//
export const TagsProvider = ({ children }) => {



    //--------------- CRIAÇÃO DOS HOOKS ---------------//
    const [tags, setTags] = useState([]); // Estado que armazena a lista de Tags
    const [tagSearched, setTagSearched] = useState(""); // Estado que armazena o texto da Busca
    const [newTagName, setNewTagName] = useState(""); // Estado que armazena a nova Tag
    const [isOpenModalDeleteTag, setIsOpenModalDeleteTag] = useState(false);
    const [formDataModalDeleteTag, setFormDataModalDeleteTag] = useState(null); // Estado que armazena se Tag deve ser deletada
    const [itemsPerPage, setItemsPerPage] = useState(10); // Estado que armazena a quantidade de Itens por Página
    const [currentPage, setCurrentPage] = useState(1); // Estado que armazena qual é a Página Atual que está sendo apresentada
    


    //--------------- RETORNO DO PROVIDER ---------------//
    return (
        <TagsContext.Provider value={{
            tags, setTags, tagSearched, setTagSearched, newTagName, setNewTagName, formDataModalDeleteTag, setFormDataModalDeleteTag, itemsPerPage, setItemsPerPage, currentPage, setCurrentPage, isOpenModalDeleteTag, setIsOpenModalDeleteTag
        }}>
            {children}
        </TagsContext.Provider>
    );



};